module.exports = __webpack_public_path__ + "static/old-oak-logo-f4b0ba92b90effb0452d03debec1c253.jpg";